import { LocationNumbersService } from "../../../services";

const fetchLocationOnboardingConfig = async function ({ commit, dispatch, state }, config) {
    const { companyId } = config

    try {
        const data = await LocationNumbersService.fetchLocationOnboardingConfig(companyId);
        return data;
    } catch (error) {
        throw error;
    }
};

export default fetchLocationOnboardingConfig;